module.exports = __webpack_public_path__ + "img/AW.fd0a73a4.png";